import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingGif from "../../assets/loading_anim.gif";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import moment from "moment";
import HourlyBurnerReportTable from "../../components/common/HourlyBurnerReportTable";

function ManifoldReport() {
  const [hourlyBurnerDetails, setHourlyBurnerDetails] = useState({});
  const [filterDate, setFilterDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const { branch_id } = useParams();
  const navigate = useNavigate();
  const access_token =
    localStorage.getItem("gassol-super-admin-token") ||
    localStorage.getItem("gassol-admin-token") ||
    localStorage.getItem("gassol-head-branch-token") ||
    localStorage.getItem("gassol-sub-branch-token");
  const currentDate = new Date();

  useEffect(() => {
    if (!access_token) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

    fetchHourlyBurnerReport(null);

    setFilterDate(currentDate);
  }, []);

  const fetchHourlyBurnerReport = async (date) => {
    setLoading(true);
    const selected_date = date == null ? "" : "&date=" + date;

    try {
      const res = await getServices(
        // `/api/burner/hourly/report?branch_id=${location.state.branch_id}${selected_date}`,
        `/api/burner/hourly/report?branch_id=${branch_id}${selected_date}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setHourlyBurnerDetails(res.responseData);
      } else {
        setHourlyBurnerDetails({});
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleFilterDateChange = (dates) => {
    fetchHourlyBurnerReport(moment(dates).format("ll"));

    setFilterDate(dates);
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        {!loading ? (
          <>
            <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
              <div className="flex gap-3 sm:gap-6">
                <Link
                  to={-1}
                  className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
                >
                  {/* <IoChevronBackOutline /> */}
                  <p>Burner Report</p>
                </Link>
              </div>
            </div>

            {/* hourly burner report table */}
            <HourlyBurnerReportTable
              hourlyBurnerDetails={hourlyBurnerDetails}
              handleFilterDateChange={handleFilterDateChange}
              filterDate={filterDate}
            />
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[90vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default ManifoldReport;
